<!-- eslint-disable max-len -->
<template>
  <div class="formLogin">
    <div v-if="!authenticated">
      <a-form-model :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="0px">
        <a-form-model-item prop="phone">
          <a-input size="large" v-model="ruleForm1.phone" placeholder="请输入手机号" allowClear
            oninput="value=value.replace(/[^0-9]/g,'');if(value.length > 11)value = value.slice(0, 11)" />
        </a-form-model-item>
        <div class="captcha">
          <a-form-model-item prop="captcha">
            <a-input size="large" v-model="ruleForm1.captcha" type="password" allowClear
              oninput="value=value.replace(/[^0-9]/g,'');if(value.length > 6)value = value.slice(0, 6)"
              placeholder="请输入验证码">
              <a-button slot="addonAfter" class="captchaButton" :disabled="captchaButtonDisabled" @click="getCaptcha">
                {{ captchaBtnContent }} </a-button>
            </a-input>
          </a-form-model-item>
        </div>
      </a-form-model>
      <Vcode :show="errVcode" @success="successVcode" @close="closeVcode" />
    </div>
    <div v-else>
      <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
        <a-form-model-item prop="pwd">
          <a-input-password size="large" v-model="ruleForm.pwd"
          oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|\s*/g,''); if(value.length > 18)value = value.slice(0, 18)" placeholder="新密码"
            allowClear />
        </a-form-model-item>
        <a-form-model-item prop="repeatPwd">
          <a-input-password size="large" v-model="ruleForm.repeatPwd"
            oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|\s*/g,''); if(value.length > 18)value = value.slice(0, 18)"
            placeholder="确认新密码" allowClear />
        </a-form-model-item>
      </a-form-model>
    </div>
    <Environment />
    <a-button class="button" @click="clickonthe" :loading="btnLoading">{{ authenticated ? '确定' : '验证手机' }}</a-button>
    <div class="go_login" @click="goLogin">返回登录</div>
  </div>
</template>

<script>
import Vcode from 'vue-puzzle-vcode';
import { message } from 'ant-design-vue';
import { get, post } from '@/utils/http';
// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/order
import { getLogo } from '@/utils/intConfiguration';
import api from '@/api';
import ErrorLogin from '@/utils/errorLogin';
import { pwdPublicKeyEncode } from '@/utils/RSAUtils';
import Environment from '../environment.vue';

export default {
  name: 'resetPsw',
  components: {
    Environment,
    Vcode,
  },
  data() {
    return {
      btnLoading: false,
      ruleForm: {
        pwd: '',
        repeatPwd: '',
      },
      ruleForm1: {
        phone: '',
        captcha: '',
      },
      rules: {
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?=(.*[A-Za-z]){1})(?=(.*\d){1})(?=(.*[\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]){1})[A-Za-z\d\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]{10,18}$/, message: '密码需包含字母+数字+特殊字符，长度10～18位', trigger: 'change' },
        ],
        repeatPwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?=(.*[A-Za-z]){1})(?=(.*\d){1})(?=(.*[\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]){1})[A-Za-z\d\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]{10,18}$/, message: '密码需包含字母+数字+特殊字符，长度10～18位', trigger: 'change' },
        ],
      },
      rules1: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: '手机号码格式不正确', trigger: 'change' },
        ],
        captcha: [],
      },
      rulesCaptcha: [
        { required: true, message: '请输入验证码', trigger: 'blur' },
        { pattern: /^[0-9]{6}$/, message: '验证码格式不正确', trigger: 'change' },
      ],
      captchaButtonDisabled: false, /// 获取验证码按钮是否禁用
      totalTime: 60, /// 倒计时
      captchaBtnContent: '获取验证码', // 按钮里显示的内容
      codeId: '', /// 验证码 id
      logoUi: getLogo(),
      authenticated: false,
      errlg: null,
      errVcode: false,
    };
  },
  mounted() {
    this.errlg = new ErrorLogin();
  },
  methods: {
    successVcode() {
      this.errVcode = false;
      this.errlg.refreshPasWord(0);
    },
    closeVcode() {
      // this.errVcode = false;
    },
    clickonthe() {
      // eslint-disable-next-line no-unused-expressions
      this.authenticated ? this.modifyPwd() : this.verifyPhone();
    },
    // 重置密码
    modifyPwd() {
      if (this.ruleForm.pwd !== this.ruleForm.repeatPwd) {
        message.error('两次输入密码不一致');
        return;
      }
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.btnLoading = true;
          // eslint-disable-next-line prefer-const
          let password = await pwdPublicKeyEncode(this.ruleForm.pwd);
          const params = {
            phone: this.ruleForm1.phone,
            newPassword: password,
          };
          await post(api.resetPassword, params).then(() => {
            this.$store.commit('switchLogin', '0');
          }).finally(() => {
            this.btnLoading = false;
          }).catch(() => { });
        }
      });
    },
    /// 获取验证码倒计时
    countDown() {
      this.captchaButtonDisabled = true;
      this.captchaBtnContent = `${this.totalTime}s`; // 这里解决60秒不见了的问题
      const clock = window.setInterval(() => {
        this.totalTime -= 1;
        this.captchaBtnContent = `${this.totalTime}s`;
        if (this.totalTime < 0) { // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.captchaBtnContent = '重新获取';
          this.totalTime = 60;
          this.captchaButtonDisabled = false;
        }
      }, 1000);
    },

    /// 获取验证码
    getCaptcha() {
      setTimeout(() => {
        this.$refs.ruleForm1.validate(async (valid) => {
          if (valid) {
            if (!this.errlg.voidCodeLogin(0)) {
              this.errVcode = true;
              return;
            }
            this.countDown();
            const params = {
              phone: this.ruleForm1.phone,
            };
            const res = await get(api.pwdSendVerifyCode, params).catch(() => {
              message.error('验证码发送失败');
              this.errlg.addErrorPhone();
            });
            this.codeId = res;
            if (res) {
              this.rules1.captcha = this.rulesCaptcha;
              message.success('验证码已发送');
              this.errlg.refreshPasWord(0);
            }
          }
        });
      }, 100);
    },
    verifyPhone() {
      setTimeout(() => {
        this.$refs.ruleForm1.validate(async (valid) => {
          if (valid) {
            this.btnLoading = true;
            const params = {
              phone: this.ruleForm1.phone,
              verifyCode: this.ruleForm1.captcha,
              codeId: this.codeId,
            };

            await post(api.verifyPhone, params).then(() => {
              this.authenticated = true;
              this.$store.commit('resetStatus', '1');
            }).finally(() => {
              this.btnLoading = false;
            }).catch(() => { });
          }
        });
      }, 100);
    },
    goLogin() {
      this.$store.commit('switchLogin', '0');
    },
  },
};
</script>
<style lang="less" >
.ant-btn:focus {
  box-shadow: none;
  border: 0 none;
  outline: none;
}
</style>
